import HttpError from 'standard-http-error';
import * as TokenHelpers from './tokenHelpers';
export const API_ROOT = WP_SERVER_URL


const EventEmitter = require('event-emitter');

/**
 * All HTTP errors are emitted on this channel for interested listeners
 */
export const errors = new EventEmitter();

function handleSuccess(response) {
  try {
    return {
      status: response.status,
      headers: response.headers,
      body: response.data
    };
  } catch (e) {
    throw e;
  }
}


export function handleError(path, error) {
  try {
    const status = error.response.status;

    if (status >= 400) {
      let errorBody = error.response.data;

      // Optimal case is JSON with a defined error property
      if (errorBody && errorBody.error) {
        errorBody = errorBody.error
      }

      // emit events on error channel, one for status-specific errors and other for all errors
      errors.emit(status.toString(), {path, message: errorBody});
      errors.emit('*', {path, message: errorBody}, status);

      return errorBody
    }
  } catch (e) {
    throw e;
  }
}

export function handleUserAuth(error) {

  return new Promise((resolve, reject) => {
    if(error && error.response && error.response.data) {
      let status = error.response.status;

      if(status === 401 || status === 404) {
        console.error("RESPONSE_STATUS", status);
        TokenHelpers.destroy();
        location = '/signin?auth=required';
      } else reject(error)
    } else reject(error)
  })
}

export function getRequestHeaders(body, token) {
  const headers = body
    ? {'Accept': 'application/json', 'Content-Type': 'application/json'}
    : {'Accept': 'application/json'};

  if (token) {
    return {...headers, Authorization: `Bearer ${token}`};
  }

  return headers;
}

// try to get the best possible error message out of a response
// without throwing errors while parsing
export function getErrorMessageSafely(response) {
  try {
    const body = response.data;
    if (!body) {
      return '';
    }

    // Should that fail, return the whole response body as text
    return body;

  } catch (e) {
    // Unreadable body, return whatever the server returned
    return e;
  }
}

/**
 * Rejects a promise after `ms` number of milliseconds, it is still pending
 */
export function timeout(promise, ms) {
  return new Promise((resolve, reject) => {
    const timer = setTimeout(() => reject(new Error('timeout')), ms);
    promise
      .then(response => {
        clearTimeout(timer);
        resolve(response);
      })
      .catch(reject);
  });
}


/**
 * Make best effort to turn a HTTP error or a runtime exception to meaningful error log message
 */
function logError(error, endpoint, method) {
  if (error.status) {
    const summary = `(${error.status} ${error.statusText}): ${error._bodyInit}`;
    console.error(`API request ${method.toUpperCase()} ${endpoint} responded with ${summary}`);
  }
  else {
    console.error(`API request ${method.toUpperCase()} ${endpoint} failed with message "${error.message}"`);
  }
}



// WEBPACK FOOTER //
// ./src/utils/apiHelper.js